import React from "react";

/**
 * 403 Component
 *
 * {@description
 *      NOTE: Not possible to return a 403 from client side React as of Mar 21, 2016
 *      {@link https://github.com/ReactTraining/react-router/issues/3210}
 * }
 */
export const Forbidden = () => {
    return (
        <div className="container">
            <h1>403: Forbidden</h1>
            <p>You do not have the necessary permissions to access this page.</p>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/error/Forbidden.jsx